import {Secondee} from "./secondee";

export class User {
	id: number;
	first_name: string;
	last_name: string;
	email: string;
    country: string;
	lang_code: string;
    entity: string;
	role: string;
    igg: string;
    eo_general: string;
    secondee: Secondee;

	constructor(data = {}) {
		Object.assign(this, data);
	}

	isAdmin(): boolean {
		return this.role.toLowerCase() === 'admin';
	}
    
    isReferent():boolean {
        return this.role.toLowerCase() === 'referent';
    }
    
    isUser():boolean {
        return this.role.toLowerCase() === 'user';
    }
    
    isRH(): boolean {
        return this.role.toLowerCase() === 'rh';
    }
}